import React from 'react';

const Skills = () => {
  const skillCategories = [
    {
      category: 'Programming Languages',
      skills: ['Python', 'JavaScript', 'Java', 'React', 'React Native'],
    },
    {
      category: 'Tools & Technologies',
      skills: ['NumPy', 'Git/GitHub', 'Cloud Platforms', 'SQL', 'Tailwind CSS', 'Django'],
    },
    {
      category: 'Development',
      skills: ['Web Development', 'Mobile Development', 'Database Management', 'Machine Learning', 'Neural Networks'],
    },
    {
      category: 'Specialized Skills',
      skills: ['OpenCV', 'NLP', 'NLTK', 'Automated Testing', 'Playwright', 'E2E Testing'],
    },
  ];

  return (
    <section id="skills" className="px-4 py-20 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-12 max-w-2xl"><p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-700">Toolbox</p><h2 className="mt-3 text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl">Technologies I work with.</h2></div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {skillCategories.map((category, index) => (
            <div
              key={index}
              className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm transition hover:-translate-y-1 hover:border-cyan-300 hover:shadow-lg hover:shadow-slate-200/70"
            >
              <h3 className="mb-5 text-xl font-bold text-slate-950">
                {category.category}
              </h3>
              <div className="flex flex-wrap gap-3">
                {category.skills.map((skill, i) => (
                  <span
                    key={i}
                    className="cursor-default rounded-lg bg-slate-100 px-3 py-2 text-sm font-medium text-slate-700 transition hover:bg-cyan-100 hover:text-cyan-900"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
